import React from 'react';
import T from 'prop-types';
import { Button } from 'antd';

import { MODAL_SIGNUP } from '../../constants/app';

class SignupButton extends React.PureComponent {
  handleClick = () => {
    const { callback } = this.props;
    this.props.updateQueryString({
      modal: MODAL_SIGNUP,
    });

    callback();
  };

  render() {
    const { ghost, className, type, block, size } = this.props;

    return (
      <Button
        block={block}
        className={className}
        data-cy="signup-btn"
        ghost={ghost}
        onClick={this.handleClick}
        size={size}
        type={type}
      >
        Sign up
      </Button>
    );
  }
}

SignupButton.propTypes = {
  updateQueryString: T.func.isRequired,

  block: T.bool,
  callback: T.func,
  className: T.string,
  ghost: T.bool,
  size: T.string,
  type: T.string,
};

SignupButton.defaultProps = {
  block: false,
  callback: () => {},
  className: '',
  ghost: false,
  size: 'default',
  type: 'default',
};

export default SignupButton;
